(function () {
  var SELECTOR = '[data-vernal-diy-expansion]';
  var APPLY_SELECTOR = '[data-diy-expansion-apply]';
  var STORAGE_KEY = 'olc_cross_page_preset';

  function parseSkuText(text) {
    if (!text) return [];
    return String(text)
      .split(/[,，;；\n\r]+/)
      .map(function (value) {
        return value.trim();
      })
      .filter(Boolean);
  }

  function writePresetToSessionStorage(payload) {
    if (!window.sessionStorage) return;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function initSection(root) {
    if (!root || root.dataset.diyExpansionInited === '1') return;
    root.dataset.diyExpansionInited = '1';

    var applyBtn = root.querySelector(APPLY_SELECTOR);
    if (!applyBtn) return;

    applyBtn.addEventListener('click', function () {
      var skuText = root.getAttribute('data-sku-text') || '';
      var skus = parseSkuText(skuText);
      if (!skus.length) return;

      var payload = {
        skus: skus,
        scroll: true,
        createdAt: Date.now(),
      };
      var targetId = root.getAttribute('data-diy-target-id');
      if (targetId) payload.targetId = targetId;

      writePresetToSessionStorage(payload);
    });
  }

  function mountAll(context) {
    var scope = context || document;
    var roots =
      scope.matches && scope.matches(SELECTOR)
        ? [scope]
        : scope.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(roots, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    mountAll(ev.target);
  });
})();
